import staticPagesMixin from './static-pages-mixin';
import Pagination from './components/forms/component.pagination.js';

import MainVue from './main-vue';

new MainVue({
    el: '#app',
    mixins: [staticPagesMixin],
    components: {
        'pagination': Pagination
    },
    data() {
        return {
            disablePrevButton:true,  
            disableNextButton:true, 
            searchResults: window.ibJS.searchResults,  
        }
    },
    created() {
    },
    mounted(){
        //get the current slide on search results
        var currentPage = window.location.pathname;
        if(currentPage == '/search-results/') {
            var owl = $('.owl-carousel');
            owl.on('changed.owl.carousel', function (e) {
                var startSlideIndex = e.item.index;
                var endSlideIndex = e.item.index + e.page.size;
                if(startSlideIndex == null || startSlideIndex === 0){
                    self.disablePrevButton = true;
                    self.disableNextButton = false;
                }else if(endSlideIndex === self.searchResults?.totalPages){
                    self.disablePrevButton = false;
                    self.disableNextButton = true;
                }else{
                    self.disablePrevButton = false;
                    self.disableNextButton = false;
                }
            })
        }

        $(document).ready(() => {
            var $searchResultsInput = $("input.search-input");

            if($searchResultsInput.length) {
                //adding ther url query values to the language link
                $(".c-Lang-H__item a").each((item, e)=>{
                    var href = e.href;
                    var isVoid = href.indexOf("javascript") == -1;
                    if(isVoid) {
                        href+=location.search;
                        e.href = href;
                    }
                });
                var $siteSearchMainForm = document.querySelector("#siteSearchMain");
                var siteSearchUrl = window.globalLanguage.searchUrl;
                if (siteSearchUrl) {
                    $searchResultsInput.on("keydown", function(e) {
                        if(e.key == 'Enter' || e.keyCode == 13) {
                            let baseUrl = siteSearchUrl;
                            let newActionUrl = baseUrl + "?q=" + encodeURIComponent($searchResultsInput.val());
                            $siteSearchMainForm.action = newActionUrl;
                            $siteSearchMainForm.submit();
                        }
                    });
                }
                if(window.ibJS.searchResults.snippets.length > 0) {
                    $(".search-container p.c-Disclaimer").each((i,item)=>item.innerHTML = item.innerHTML.replace(/&nbsp;/g,' '));
                }
                setTimeout(()=>{
                    var $pagination = $(".pagination-post");
                    var $query = window.ibJS.searchResults.query;
                    $pagination.click((e)=>{
                        var pageSelected = $(e.currentTarget).attr("data-page");
                        var data = {
                            "query": $query,
                            "page": pageSelected
                        };
                        var $siteSearchMainForm = document.querySelector("#siteSearchMain");
                        var $inputField = document.querySelector("#siteSearchMain .search-input");
                        var $pageField = document.querySelector("#search-page");
                        $inputField.value = data.query;
                        $pageField.value = data.page;
                        $siteSearchMainForm.action = window.globalLanguage.searchUrl;
                        $siteSearchMainForm.submit();
                    });
                },1000);
            }
        })
    },
    methods:{
    }
})